import { endOfMonth, startOfMonth } from 'date-fns';

export const mockPodiumPrizes = [
	{
		startDate: startOfMonth(new Date(0)),
		endDate: endOfMonth(new Date().setFullYear(2024, 10, 1)),
		byRevenue: {
			gold: {
				prize: '1 000',
				goods: ['Brand Collaboration', 'Package of Goods from brands'],
			},
			silver: {
				prize: '500',
				goods: ['Package of Goods from brands'],
			},
			bronze: {
				goods: ['Package of Goods from brands'],
			},
		},
		byAttendees: {
			gold: {
				prize: '1 000',
				goods: ['Brand Collaboration', 'Package of Goods from brands'],
			},
			silver: {
				prize: '500',
				goods: ['Package of Goods from brands'],
			},
			bronze: {
				goods: ['Package of Goods from brands'],
			},
		},
	},
	{
		startDate: startOfMonth(new Date().setFullYear(2025, 0, 1)),
		endDate: endOfMonth(new Date().setFullYear(2025, 1, 1)),
		byRevenue: {
			gold: {
				prize: '1 000',
			},
			silver: {
				prize: '300',
			},
			bronze: {
				prize: '200',
			},
		},
		byAttendees: {
			gold: {
				prize: '1 000',
			},
			silver: {
				prize: '300',
			},
			bronze: {
				prize: '200',
			},
		},
	}
];
